module.exports = __webpack_public_path__ + "media/images/common/credit_cards/visa-62ac1300524954ee54c2b601d6fffaa2.svg";